@if (!users) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
<mat-toolbar class="mb-2">
  <mat-icon mat-list-icon>supervisor_account</mat-icon>
  <span class="container-fluid">
    <h1>Lista användare</h1>
  </span>
  <span class="example-spacer"></span>
  <button mat-mini-fab matTooltip="Lägg till ny användare" (click)="addNewUser()"><mat-icon>person_add</mat-icon>
</button>
</mat-toolbar>
<div class="container-fluid">

  <mat-form-field>
    <mat-label>Sök användare...</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Sök användare...">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-paginator [pageSizeOptions]="[10, 15, 25, 100]" [pageSize]="50"></mat-paginator>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let user"> {{user.position}} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Namn </th>
      <td mat-cell *matCellDef="let user"> {{user.firstname}} {{user.lastname}}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let user"> {{user.email}} </td>
    </ng-container>

    <ng-container matColumnDef="mobile">
      <th mat-header-cell *matHeaderCellDef> Telefonnummer </th>
      <td mat-cell *matCellDef="let user"> {{user.mobile}} </td>
    </ng-container>

    <ng-container matColumnDef="smsVerification">
      <th mat-header-cell *matHeaderCellDef> SMS </th>
      <td mat-cell *matCellDef="let user">
        @if (user.smsVerification) {
          <mat-icon class="material-icons text-success">sms</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="roles">
      <th mat-header-cell *matHeaderCellDef> Användartyp </th>
      <td mat-cell *matCellDef="let user"> {{user.roles}} </td>
    </ng-container>

    <ng-container matColumnDef="accessLevel">
      <th mat-header-cell *matHeaderCellDef> Admin </th>
      <td mat-cell *matCellDef="let user">
        @if (user.accessLevel>0) {
          <mat-icon class="material-icons text-success">verified_user</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="isApproved">
      <th mat-header-cell *matHeaderCellDef> Aktiverad </th>
      <td mat-cell *matCellDef="let user">
        @if (user.isApproved) {
          <mat-icon class="material-icons text-success">check_circle</mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef> Skapad </th>
      <td mat-cell *matCellDef="let user"> {{ user.created | date }} </td>
    </ng-container>

    <ng-container matColumnDef="lastLogin">
      <th mat-header-cell *matHeaderCellDef> Senast inloggad </th>
      <td mat-cell *matCellDef="let user"> {{ user.lastLogin | date }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openEdit(row)"></tr>
  </table>

</div>
